<div *ngIf="loading" class="overlay">
  <div class="spinner"></div>
</div>

 
  <blockquote>
    <h5 class="headings">REGULATORY/ STATUTORY DOCUMENTS</h5>
  </blockquote>
  <form #form="ngForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <p class="error">{{error_message}}</p>
    </div>
    <div class="card">
      <div class="radio-row">
        <h6>1. VAT</h6>
        <div class="radio-options">
          <label>
            <input name="group2" type="radio" [value]="'yes'" [disabled]="isViewOnly" [(ngModel)]="documents.hasVatDocument" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">Yes</span>
          </label>
          <label>
            <input name="group2" type="radio" [value]="'no'" [(ngModel)]="documents.hasVatDocument" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">No</span>
          </label>
          <label>
            <input name="group2" type="radio" [value]="'na'" [(ngModel)]="documents.hasVatDocument" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">NA</span>
          </label>
        </div>
      </div>
      <div *ngIf="documents.hasVatDocument === 'yes'">
        <div class="row s12">
          <div class="col s6" style="padding: 0;">
            <h6>You selected YES, provide VAT Registration No.: </h6>
            <input type="text" name="vatno" class="white-input" [readOnly]="isViewOnly" [(ngModel)]="documents.vatRegistrationNo" (ngModelChange)="resetErrorMessage()">
          </div>
          <div class="col s6">
            <h6>VAT Registration Expiry Date: </h6>
            <input type="date" name="vatexpirydate" class="white-input" [readOnly]="isViewOnly" [min]="minDate" [(ngModel)]="documents.vatExpiryDate" (ngModelChange)="resetErrorMessage()">
          </div>
        </div>
        <!--*ngIf="isViewOnly" DISPLAY FILE LINK HERE, if none display 'No file uploaded'-->
        <div *ngIf="isViewOnly && documents.vatFileData && documents.vatFilePath">
          <p>
            VAT File: 
            <a 
              [href]="'data:application/pdf;base64,' + documents.vatFileData" 
              [download]="documents.vatFilePath" 
              target="_blank"
              rel="noopener noreferrer"
              style="color: #079AFE;"
              >
              {{ documents.vatFilePath }}
            </a>
          </p>
        </div>
        <div *ngIf="!isViewOnly">
          <h6>Please upload valid form of registration.</h6>
          <label class="custom-file-upload">
            <input type="file" (change)="onFileSelected($event, 'vatFile')">
              Upload File
          </label>
          <label class="file-info">File type must be PDF. Upload New file to replace an existing upload.</label>
          <p *ngIf="documents.vatFile || documents.vatFilePath " style="color: #E65F53;"> 
            <i class="tiny icon-inline material-icons">insert_drive_file</i>
            <span *ngIf="documents.vatFile">{{ documents.vatFile.name }}</span>
            <span *ngIf="!documents.vatFile && documents.vatFilePath">
              <a 
                [href]="'data:application/pdf;base64,' + documents.vatFileData" 
                [download]="documents.vatFilePath" 
                target="_blank"
                rel="noopener noreferrer"
                style="color: #079AFE;"
              >
                {{ documents.vatFilePath }}
              </a>
            </span>
          </p>

        </div>
      </div>

      <div *ngIf="documents.hasVatDocument === 'no'">
        <h6>You selected NO, provide details: </h6>
        <input type="text" name="noVatReason" class="white-input" [readOnly]="isViewOnly" [(ngModel)]="documents.noVatReason" (ngModelChange)="resetErrorMessage()">
      </div>
    </div>

    <div class="card">
      <div class="radio-row">
        <h6>2. BIR</h6>
        <div class="radio-options">
          <label>
            <input name="group3" type="radio" [value]="'yes'" [disabled]="isViewOnly" [(ngModel)]="documents.hasBirDocument" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">Yes</span>
          </label>
          <label>
            <input name="group3" type="radio" [value]="'no'" [(ngModel)]="documents.hasBirDocument" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">No</span>
          </label>
          <label>
            <input name="group3" type="radio" [value]="'NA'" [(ngModel)]="documents.hasBirDocument" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">NA</span>
          </label>
        </div>
      </div>
      <div *ngIf="documents.hasBirDocument === 'yes'">
        <div class="row s12">
          <div class="col s6" style="padding: 0;">
            <h6>You selected yes, provide BIR No.: </h6>
            <input type="text" name="birno"  class="white-input" [readOnly]="isViewOnly" [(ngModel)]="documents.birNo" (ngModelChange)="resetErrorMessage()">
          </div>
          <!-- <div class="col s6">
            <h6>BIR Expiry Date: </h6>
            <input type="date" name="birexpirydate" class="white-input" [readOnly]="isViewOnly" [min]="minDate" [(ngModel)]="documents.birExpiryDate" (ngModelChange)="resetErrorMessage()">
          </div> -->
        </div>
        <!--*ngIf="isViewOnly" DISPLAY FILE LINK HERE, if none display 'No file uploaded'-->
        <div *ngIf="isViewOnly && documents.birFileData && documents.birFilePath">
          <p>
            BIR File: 
            <a 
              [href]="'data:application/pdf;base64,' + documents.birFileData" 
              [download]="documents.birFilePath" 
              target="_blank"
              rel="noopener noreferrer"
              style="color: #079AFE;"
              >
              {{ documents.birFilePath }}
            </a>
          </p>
        </div>
        <div *ngIf="!isViewOnly">
          <h6>Please upload valid Compliance Certificate.</h6>
          <label class="custom-file-upload">
            <input type="file" (change)="onFileSelected($event, 'birFile')">
              Upload File
          </label>
          <label class="file-info">File type must be PDF. Upload New file to replace an existing upload.</label>
          <p *ngIf="documents.birFile || documents.birFilePath " style="color: #E65F53;"> 
            <i class="tiny icon-inline material-icons">insert_drive_file</i>
            <span *ngIf="documents.birFile">{{ documents.birFile.name }}</span>
            <span *ngIf="!documents.birFile && documents.birFilePath">
              <a 
                [href]="'data:application/pdf;base64,' + documents.birFileData"
                [download]="documents.birFilePath" 
                target="_blank"
                rel="noopener noreferrer"
                style="color: #079AFE;"
              >
                {{ documents.birFilePath }}
              </a>
            </span>
          </p>
        </div>
        
      </div>
      <div *ngIf="documents.hasBirDocument === 'no'">
        <h6>You selected NO, provide details: </h6>
        <input type="text" name="noBirReason" class="white-input" [readOnly]="isViewOnly" [(ngModel)]="documents.noBirReason" (ngModelChange)="resetErrorMessage()">
      </div>
    </div>

    <div class="card">
      <div class="radio-row">
        <h6>3. NIB</h6>
        <div class="radio-options">
          <label>
            <input name="group4" type="radio" [value]="'yes'" [disabled]="isViewOnly" [(ngModel)]="documents.hasNibDocument" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">Yes</span>
          </label>
          <label>
            <input name="group4" type="radio" [value]="'no'" [(ngModel)]="documents.hasNibDocument" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">No</span>
          </label>
          <label>
            <input name="group4" type="radio" [value]="'NA'" [(ngModel)]="documents.hasNibDocument" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">NA</span>
          </label>
        </div>
      </div>
      <div *ngIf="documents.hasNibDocument === 'yes'">
        <div class="row s12">
          <div class="col s6" style="padding: 0;">
            <h6>You selected yes, provide NIB No.: </h6>
            <input type="text" name="nibno"  class="white-input" [readOnly]="isViewOnly" [(ngModel)]="documents.nibNo" (ngModelChange)="resetErrorMessage()">
          </div>
          <div class="col s6">
            <h6>NIB Registration Expiry Date: </h6>
            <input type="date" name="nibexpiry" class="white-input" [readOnly]="isViewOnly" [min]="minDate" [(ngModel)]="documents.nibExpiryDate" (ngModelChange)="resetErrorMessage()">
          </div>
        </div>
        <!--*ngIf="isViewOnly" DISPLAY FILE LINK HERE, if none display 'No file uploaded'-->
        <div *ngIf="isViewOnly && documents.nibFileData && documents.nibFilePath">
          <p>
            NIB File: 
            <a 
              [href]="'data:application/pdf;base64,' + documents.nibFileData" 
              [download]="documents.nibFilePath" 
              target="_blank"
              rel="noopener noreferrer"
              style="color: #079AFE;"
              >
              {{ documents.nibFilePath }}
            </a>
          </p>
        </div>
        <div *ngIf="!isViewOnly">
          <h6>Please upload valid form of registration.</h6>
          <label class="custom-file-upload">
            <input type="file" (change)="onFileSelected($event, 'nibFile')">
              Upload File
          </label>
          <label class="file-info">File type must be PDF. Upload New file to replace an existing upload.</label>
          <p *ngIf="documents.nibFile || documents.nibFilePath"  style="color: #E65F53;"> 
            <i class="tiny icon-inline material-icons">insert_drive_file</i>
            <span *ngIf="documents.nibFile">{{ documents.nibFile.name }}</span>
            <span *ngIf="!documents.nibFile && documents.nibFilePath">
              <a 
                [href]="'data:application/pdf;base64,' + documents.nibFileData" 
                [download]="documents.nibFilePath" 
                target="_blank"
                rel="noopener noreferrer"
                style="color: #079AFE;"
              >
                {{ documents.nibFilePath }}
              </a>
            </span>
          </p>
        </div>
      </div>
      <div *ngIf="documents.hasNibDocument === 'no'">
        <h6>You selected NO, provide details: </h6>
        <input type="text" name="noNibReason" class="white-input" [readOnly]="isViewOnly" [(ngModel)]="documents.noNibReason" (ngModelChange)="resetErrorMessage()">
      </div>
    </div>

    <div class="card">
      <div class="radio-row">
        <h6>4. Certificate of Incorporation</h6>
        <div class="radio-options">
          <label>
            <input name="group5" type="radio" [value]="'yes'" [disabled]="isViewOnly" [(ngModel)]="documents.hasIncorporationCertificate" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">Yes</span>
          </label>
          <label>
            <input name="group5" type="radio" [value]="'no'" [(ngModel)]="documents.hasIncorporationCertificate" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">No</span>
          </label>
          <label>
            <input name="group5" type="radio" [value]="'NA'" [(ngModel)]="documents.hasIncorporationCertificate" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">NA</span>
          </label>
        </div>
      </div>
      <div *ngIf="documents.hasIncorporationCertificate === 'yes'">
        <br>
        <!--*ngIf="isViewOnly" DISPLAY FILE LINK HERE, if none display 'No file uploaded'-->
        <div *ngIf="isViewOnly && documents.incorpFileData && documents.incorporationFilePath">
          <p>
            Incorporation File: 
            <a 
              [href]="'data:application/pdf;base64,' + documents.incorpFileData" 
              [download]="documents.incorporationFilePath" 
              target="_blank"
              rel="noopener noreferrer"
              style="color: #079AFE;"
              >
              {{ documents.incorporationFilePath }}
            </a>
          </p>
        </div>
        <div *ngIf="!isViewOnly">
          <h6>Please upload valid Certificate.</h6>
          <label class="custom-file-upload">
            <input type="file" (change)="onFileSelected($event, 'incorpFile')">
              Upload File
          </label>
          <label class="file-info">File type must be PDF. Upload New file to replace an existing upload.</label>
          <p *ngIf="documents.incorpFile || documents.incorporationFilePath" style="color: #E65F53;"> 
            <i class="tiny icon-inline material-icons">insert_drive_file</i>
            <span *ngIf="documents.incorpFile">{{ documents.incorpFile.name }}</span>
            <span *ngIf="!documents.incorpFile && documents.incorporationFilePath">
              <a 
                [href]="'data:application/pdf;base64,' + documents.incorpFileData" 
                [download]="documents.incorporationFilePath" 
                target="_blank"
                rel="noopener noreferrer"
                style="color: #079AFE;"
              >
                {{ documents.incorporationFilePath }}
              </a>
            </span>
          </p>
        </div>
      </div>
      <div *ngIf="documents.hasIncorporationCertificate === 'no'">
        <h6>You selected NO, provide details: </h6>
        <input type="text" name="noIncorporationReason" class="white-input" [readOnly]="isViewOnly" [(ngModel)]="documents.noIncorporationReason" (ngModelChange)="resetErrorMessage()">
      </div>
    </div>

    <div class="card">
      <div class="radio-row">
        <h6>5. Certificate of Registration</h6>
        <div class="radio-options" >
          <label>
            <input name="group6" type="radio" [value]="'yes'" [disabled]="isViewOnly" [(ngModel)]="documents.hasRegistrationCertificate" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">Yes</span>
          </label>
          <label>
            <input name="group6" type="radio" [value]="'no'" [(ngModel)]="documents.hasRegistrationCertificate" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">No</span>
          </label>
          <label>
            <input name="group6" type="radio" [value]="'NA'" [(ngModel)]="documents.hasRegistrationCertificate" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">NA</span>
          </label>
        </div>
      </div>
      <div *ngIf="documents.hasRegistrationCertificate === 'yes'">
        <br>
        <!--*ngIf="isViewOnly" DISPLAY FILE LINK HERE, if none display 'No file uploaded'-->
        <div *ngIf="isViewOnly && documents.regFileData && documents.registrationFilePath">
          <p>
            Registration File: 
            <a 
              [href]="'data:application/pdf;base64,' + documents.regFileData" 
              [download]="documents.registrationFilePath" 
              target="_blank"
              rel="noopener noreferrer"
              style="color: #079AFE;"
              >
              {{ documents.registrationFilePath }}
            </a>
          </p>
        </div>
        <div *ngIf="!isViewOnly">
          <h6>Please upload valid Certificate of Registration.</h6>
          <label class="custom-file-upload">
            <input type="file" (change)="onFileSelected($event, 'regFile')">
              Upload File
          </label>
          <label class="file-info">File type must be PDF. Upload New file to replace an existing upload.</label>
          <p *ngIf="documents.regFile || documents.registrationFilePath" style="color: #E65F53;"> 
            <i class="tiny icon-inline material-icons">insert_drive_file</i>
           <span *ngIf="documents.regFile">{{ documents.regFile.name }}</span>
           <span *ngIf="!documents.regFile && documents.registrationFilePath">
              <a 
                [href]="'data:application/pdf;base64,' + documents.regFileData" 
                [download]="documents.registrationFilePath" 
                target="_blank"
                rel="noopener noreferrer"
                style="color: #079AFE;"
              >
                {{ documents.registrationFilePath }}
              </a>
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="radio-row">
        <h6>6. Do you have a company profile?</h6>
        <div class="radio-options">
          <label>
            <input name="group7" type="radio" [value]="'yes'" [disabled]="isViewOnly" [(ngModel)]="documents.hasCompanyProfile" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">Yes</span>
          </label>
          <label>
            <input name="group7" type="radio" [value]="'no'" [(ngModel)]="documents.hasCompanyProfile" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">No</span>
          </label>
          <label>
            <input name="group7" type="radio" [value]="'NA'" [(ngModel)]="documents.hasCompanyProfile" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">NA</span>
          </label>
        </div>
      </div>
      <div *ngIf="documents.hasCompanyProfile === 'yes'">
        <br>
        <!--*ngIf="isViewOnly" DISPLAY FILE LINK HERE, if none display 'No file uploaded'-->
        <div *ngIf="isViewOnly && documents.companyFileData && documents.companyProfilePath">
          <p>
            Company Profile File: 
            <a 
              [href]="'data:application/pdf;base64,' + documents.companyFileData" 
              [download]="documents.companyProfilePath" 
              target="_blank"
              rel="noopener noreferrer"
              style="color: #079AFE;"
              >
              {{ documents.companyProfilePath }}
            </a>
          </p>
        </div>
        <div *ngIf="!isViewOnly">
          <h6>Please upload relevant document specific to your company as single PDF.</h6>
          <label class="custom-file-upload">
            <input type="file" (change)="onFileSelected($event, 'compFile')">
              Upload File
          </label>
          <label class="file-info">File type must be PDF. Upload New file to replace an existing upload.</label>
          <p *ngIf="documents.companyFile || documents.companyProfilePath" style="color: #E65F53;"> 
            <i class="tiny icon-inline material-icons">insert_drive_file</i>
            <span *ngIf="documents.companyFile">{{ documents.companyFile.name }}</span>
            <span *ngIf="!documents.companyFile && documents.companyProfilePath">
                <a 
                  [href]="'data:application/pdf;base64,' + documents.companyFileData" 
                  [download]="documents.companyProfilePath" 
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: #079AFE;"
                >
                  {{ documents.companyProfilePath }}
                </a>
              </span>
          </p>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="radio-row">
        <h6>7. Licenses and Certifications applicable to your operations.</h6>
        <div class="radio-options">
          <label>
            <input name="group8" type="radio" [value]="'yes'" [disabled]="isViewOnly" [(ngModel)]="documents.hasGeneralLicenses" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">Yes</span>
          </label>
          <label>
            <input name="group8" type="radio" [value]="'no'" [(ngModel)]="documents.hasGeneralLicenses" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">No</span>
          </label>
          <label>
            <input name="group8" type="radio" [value]="'NA'" [(ngModel)]="documents.hasGeneralLicenses" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">NA</span>
          </label>
        </div>
      </div>
      <div *ngIf="documents.hasGeneralLicenses === 'yes'">
        <br>
        <!--*ngIf="isViewOnly" DISPLAY FILE LINK HERE, if none display 'No file uploaded'-->
        <div *ngIf="isViewOnly && documents.generalLicensesFileData && documents.generalLicensesPath">
          <p>
            Licenses File: 
            <a 
              [href]="'data:application/pdf;base64,' + documents.generalLicensesFileData" 
              [download]="documents.generalLicensesPath" 
              target="_blank"
              rel="noopener noreferrer"
              style="color: #079AFE;"
              >
              {{ documents.generalLicensesPath }}
            </a>
          </p>
        </div>
        <div *ngIf="!isViewOnly">
          <h6>Please upload relevant documents as single PDF.</h6>
          <label class="custom-file-upload">
            <input type="file" (change)="onFileSelected($event, 'licFile')">
              Upload File
          </label>
          <p *ngIf="documents.licenseFile || documents.generalLicensesPath" style="color: #E65F53;"> 
            <i class="tiny icon-inline material-icons">insert_drive_file</i>
            <span *ngIf="documents.licenseFile">{{ documents.licenseFile.name }}</span>
            <span *ngIf="!documents.licenseFile && documents.generalLicensesPath">
                <a 
                  [href]="'data:application/pdf;base64,' + documents.generalLicensesFileData" 
                  [download]="documents.generalLicensesPath" 
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: #079AFE;"
                >
                  {{ documents.generalLicensesPath }}
                </a>
              </span>
          </p>
          <br>
          <label>Compile any licenses to a single a PDF and upload.</label>
        </div>
        <h6>Closest Expiry Date: </h6>
        <input type="date" name="licensesexpiry" class="white-input" [readOnly]="isViewOnly" [min]="minDate" [(ngModel)]="documents.nibExpiryDate" (ngModelChange)="resetErrorMessage()">
      </div>
    </div>
  </form>